// check that page has loaded
const isClient = () => {
  return typeof window != 'undefined' && window.document;
};

const getHostname = () => {
  if (isClient())
    return window.location.pathname.substring(1) || "/";
};

const getHost = () => {
  if (isClient())
    return window.location.host;
};

const getReferrer = () => {
  if (isClient())
    return document.referrer;
};

export default {
  isClient,
  getHostname,
  getReferrer,
  getHost,
};
